import DataStore from "../../store";
import GMPAPI from "../../services/gmpapi";

import StopServiceAccount from "./StopServiceAccount.vue";
import StopServiceFlow from "./StopServiceFlow.vue";
import StopServiceComplete from "./StopServiceComplete.vue";
import StopServiceFatalError from "./StopServiceFatalError.vue";

const loc = window.location;
const transitLoginHref = '/transit-login?redirect=' + encodeURIComponent(loc.pathname + loc.hash + loc.search);

export const StopServiceRouterOptions = {
  mode: "history",
  base: "/stop-service",
  // When going to a page, scroll to the slat id
  scrollBehavior(to, from, savedPosition) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve({
          selector: to.params.page ? ("#stop-slat-" + to.params.page) : "#top-target",
          offset: { x: 0, y: 12 },
        });
      }, 50);
    });
  },
  routes: [
    { path: "/", redirect: "/account" },
    {
      path: "/account",
      component: StopServiceAccount,
      beforeEnter: async (to, from, next) => {
        try {
          DataStore.commit("setRouteLoading", true);
          await GMPAPI.GetCurrentUser();
          // We have auth, but may not have user info
          if (!DataStore.state.user.userinfo) {
            try {
              await DataStore.dispatch("AttemptCookieLogin");
              next();
            } catch (err) {
              window.location.href = transitLoginHref;
            }
          } else {
            next();
          }
        } catch (err) {
          window.location.href = transitLoginHref;
        } finally {
          DataStore.commit("setRouteLoading", false);
        }
      }
    },
    {
      path: "/stop/:page",
      component: StopServiceFlow,
      beforeEnter: (to, from, next) => {
        if (!DataStore.state.user.currentAccount) {
          next("/account");
        } else if (to.params.page > 1 && from.path === "/") {
          // Don't let them refresh to pages after 1
          next("/stop/1");
        } else {
          next();
        }
      },
    },
    {
      path: "/complete",
      component: StopServiceComplete,
    },
    { path: "/error/:code?", component: StopServiceFatalError },
  ],
};

export function StopServiceRouterInit(router) {
  // No external init needed
}